import { OktaAuth } from '@okta/okta-auth-js';
import { config } from '../config/env';

const OKTA_ISSUER = config.oktaIssuer;
const OKTA_CLIENT_ID = config.oktaClientId;
const REDIRECT_URI = `${window.location.origin}/callback`;

if (!OKTA_ISSUER || !OKTA_CLIENT_ID) {
  console.error('Missing Okta configuration. Please set SELF_SERVICE_UI_OKTA_ISSUER / SELF_SERVICE_UI_OKTA_CLIENT_ID');
}

// Deliberately minimal scopes — no okta.* management scopes. This app must
// never be able to satisfy the admin API's audience/scope requirements.
// The okta.accessRequests.* scopes back the Request Access page: the
// adapter forwards this same delegated user token to Okta's "My Catalogs"
// / "My Requests" governance APIs rather than using a service credential,
// since those "my" endpoints are end-user-scoped by design.
export const oktaAuth = new OktaAuth({
  issuer: OKTA_ISSUER,
  clientId: OKTA_CLIENT_ID,
  redirectUri: REDIRECT_URI,
  scopes: [
    'openid',
    'profile',
    'email',
    'okta.apps.read',
    'okta.users.read.self',
    'okta.accessRequests.catalog.read',
    'okta.accessRequests.request.read',
    'okta.accessRequests.request.manage',
    // Backs Agent Owners' approval actions (My Tasks governance API).
    // Confirmed against a real org — note the plural "tasks".
    'okta.accessRequests.tasks.read',
    'okta.accessRequests.tasks.manage',
  ],
  pkce: true,
  tokenManager: {
    autoRenew: true,
    storage: 'sessionStorage'
  }
});
